import { Person } from '../../antrag.model.types';

export function isPersonInSparte(person: Person, sparte: string): boolean {
  return (
    person.angebotsBeziehung &&
    person.angebotsBeziehung.filter((beziehung) => beziehung.sparte === sparte || (sparte === 'L' && !beziehung.sparte))
      .length > 0
  );
}
